import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TransportRoutesDataGrid } from "src/components/views/erp/sales/masterData/transportRoutes/TransportRoutesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/transportRoutes")({
	staticData: { title: i18n.t("transport_routes"), legacyViewKey: "transportRoutesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TransportRoutesDataGrid />;
}
